// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__vb63o","l20-1":"Loader_l20-1__XQJb5","l20-2":"Loader_l20-2__AsRxE"};